import { useIntl } from 'react-intl'
import { loyaltyUnitMessages } from 'constants/config/i18nMessages'

interface Props {
  statusCredits: number
}

/**
 * Formats a loyalty status credits count with the correct plural unit label.
 *
 * @example
 * <FormatLoyaltyStatusCredits statusCredits={5} />   // "5 Status Credits"
 * <FormatLoyaltyStatusCredits statusCredits={1} />   // "1 Status Credit"
 */
function FormatLoyaltyStatusCredits({ statusCredits }: Props) {
  const intl = useIntl()
  return <>{intl.formatMessage(loyaltyUnitMessages.statusCreditsCount, { count: statusCredits })}</>
}

export default FormatLoyaltyStatusCredits
